import React, { type ReactNode } from "react";
import { Flex, Box, type BoxProps, Text } from "@chakra-ui/react";
import { Section, sectionSpacingY } from "components/section";
import { Container } from "ui/container";
import { TextTitle } from "ui/text";

type AnimationSectionProps = {
  chip: string;
  title: string;
  description: string;
  animation: ReactNode;
  animationProps: Pick<BoxProps, "w" | "left">;
  mobile: ReactNode;
};
export function AnimationSection({
  chip,
  title,
  description,
  animation,
  animationProps,
  mobile,
}: AnimationSectionProps) {
  return (
    <Section
      fullWidth
      noContainerPx
      bg="new.violet.950"
      themeBgColor="new.violet.950"
      theme="dark"
      display="flex"
      h={{ base: "auto", lg: "100vh" }}
      maxH={{ base: "auto", lg: "600px", xl: "840px", "2xl": "1000px" }}
      pos="relative"
      overflow="hidden"
      py="0"
      pb={sectionSpacingY}
    >
      <Flex
        display={{ base: "none", lg: "flex" }}
        pos="absolute"
        align="center"
        top={{ base: "-10%", xl: "0" }}
        bottom={0}
        right={0}
        left={animationProps?.left}
        w={animationProps?.w}
        maxW="1600px"
        height="auto"
      >
        {animation}
      </Flex>

      {mobile && (
        <Box display={{ base: "block", lg: "none" }} w="100%" maxW="860px" ml="auto">
          {mobile}
        </Box>
      )}

      <Container h="100%" mt={{ base: "-60px", md: "-84px", lg: "big" }}>
        <Flex align="center" h={{ base: "auto", lg: "100%" }} flexDir={{ base: "column", lg: "row" }} pos="relative">
          <TextTitle
            maxW={{ base: "xl", lg: "42%" }}
            mx={{ base: "auto", lg: "unset" }}
            h="100%"
            justify="center"
            zIndex={1}
            theme="dark"
            align="start"
            size="lg"
            chip={{ text: chip }}
            titleAs="h3"
            title={title}
            description={
              <Text as="span" textStyle="caption1">
                {description}
              </Text>
            }
          />
        </Flex>
      </Container>
    </Section>
  );
}
